import { createReducer } from 'reduxsauce';
import { isEqual, cloneDeep, filter } from 'lodash';

import { ReportsTypes } from '../actions/reports.actions';

const initialState = {
  status: [],
  mtdCurrentRepossessed: {},
  mtdPreviousRepossessed: {},
  mtdCurrentMissedRepossessed: 0,
  mtdPreviousMissedRepossessed: 0,
  mtdCurrentAssigned: {},
  mtdPreviousAssigned: {},
  mtdytdCompanyUncategorized: {
    mtd: { assigned: 0, respossessed: 0 },
    ytd: { assigned: 0, respossessed: 0 },
  },
  pcymCompanyStats: {},
  ytdCompanyStats: {},
  mtdytdClientsStats: {},
  topAgents: [],
  topCameras: [],
  topSpotters: [],
  mtdytdClientUncategorized: {
    mtd: { assigned: 0, respossessed: 0 },
    ytd: { assigned: 0, respossessed: 0 },
  },
  ytdClientStats: {},
  mtdPastYearsClientStats: {},
  dailyEmployeesShift: {},
  weeklyEmployeesShift: {},
  dailyViewStats: {},
  dailyCameraHitsStats: {},
};

const createClientGoalForBonusSuccess = (state, action) => {
  const client_goal = action.response.goal;

  const mtdytdClientsStats = cloneDeep(state.mtdytdClientsStats);
  const mtdPastYearsClientStats = cloneDeep(state.mtdPastYearsClientStats);

  const duration = client_goal.duration.toLowerCase();
  if (mtdytdClientsStats[duration]) {
    const mtdytdClientsStatsByDuration = mtdytdClientsStats[duration];
    const branches = Object.keys(mtdytdClientsStatsByDuration);
    branches.forEach((branch) => {
      const branchStats = mtdytdClientsStatsByDuration[branch];
      const clientIndex = branchStats.findIndex((stat) => stat.clientId === client_goal.clientId);
      if (clientIndex > -1) {
        mtdytdClientsStats[duration][branch][clientIndex].goal = client_goal;
      }
    });
  }

  if (
    mtdPastYearsClientStats.goalForBonus &&
    mtdPastYearsClientStats.goalForBonus.id &&
    mtdPastYearsClientStats.goalForBonus.id === client_goal.id
  ) {
    mtdPastYearsClientStats.goalForBonus = client_goal;
  }

  return { ...state, mtdytdClientsStats, mtdPastYearsClientStats };
};
const updateClientGoalForBonusSuccess = (state, action) => {
  const client_goal = action.response.goal;

  const mtdytdClientsStats = cloneDeep(state.mtdytdClientsStats);
  const mtdPastYearsClientStats = cloneDeep(state.mtdPastYearsClientStats);

  const duration = client_goal.duration.toLowerCase();
  if (mtdytdClientsStats[duration]) {
    const mtdytdClientsStatsByDuration = mtdytdClientsStats[duration];
    const branches = Object.keys(mtdytdClientsStatsByDuration);
    branches.forEach((branch) => {
      const branchStats = mtdytdClientsStatsByDuration[branch];
      const clientIndex = branchStats.data.findIndex((stat) => stat.clientId === client_goal.clientId);
      if (clientIndex > -1) {
        mtdytdClientsStats[duration][branch].data[clientIndex].goal = client_goal;
      }
    });
  }

  if (
    mtdPastYearsClientStats.goalForBonus &&
    mtdPastYearsClientStats.goalForBonus.id &&
    mtdPastYearsClientStats.goalForBonus.id === client_goal.id
  ) {
    mtdPastYearsClientStats.goalForBonus = client_goal;
  }

  return { ...state, mtdytdClientsStats, mtdPastYearsClientStats };
};

const getMTDYTDClientUncategorizedRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-mtdytd-client-uncategorized');

  return { ...state, status };
};
const getMTDYTDClientUncategorizedSuccess = (state, action) => {
  const { response } = action;

  const mtdUncategorized = {
    assigned: response.MTDAssignments,
    respossessed: response.MTDRepossessions,
  };
  const ytdUncategorized = {
    assigned: response.YTDAssignments,
    respossessed: response.YTDRepossessions,
  };

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-mtdytd-client-uncategorized', a));

  return {
    ...state,
    mtdytdClientUncategorized: {
      mtd: mtdUncategorized,
      ytd: ytdUncategorized,
    },
    status,
  };
};
const getMTDYTDClientUncategorizedFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-mtdytd-client-uncategorized', a));

  return { ...state, status };
};

const getYTDClientStatsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-ytd-client-stats');

  return { ...state, status };
};
const getYTDClientStatsSuccess = (state, action) => {
  const ytdClientStats = action.response ? action.response : {};
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-ytd-client-stats', a));

  return { ...state, ytdClientStats, status };
};
const getYTDClientStatsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-ytd-client-stats', a));

  return { ...state, status };
};

const getMTDPastYearsClientStatsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-mtd-past-years-client-stats');

  return { ...state, status };
};
const getMTDPastYearsClientStatsSuccess = (state, action) => {
  const mtdPastYearsClientStats = action.response ? action.response : {};
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-mtd-past-years-client-stats', a));

  return { ...state, mtdPastYearsClientStats, status };
};
const getMTDPastYearsClientStatsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-mtd-past-years-client-stats', a));

  return { ...state, status };
};

const getDailyEmployeesShiftRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-daily-employees-shift');

  return { ...state, status };
};
const getDailyEmployeesShiftSuccess = (state, action) => {
  const dailyEmployeesShift = action.response ? action.response : {};
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-daily-employees-shift', a));

  return { ...state, dailyEmployeesShift, status };
};
const getDailyEmployeesShiftFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-daily-employees-shift', a));

  return { ...state, status };
};

const getWeeklyEmployeesShiftRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-weekly-employees-shift');

  return { ...state, status };
};
const getWeeklyEmployeesShiftSuccess = (state, action) => {
  const weeklyEmployeesShift = action.response ? action.response : {};
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-weekly-employees-shift', a));

  return { ...state, weeklyEmployeesShift, status };
};
const getWeeklyEmployeesShiftFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-weekly-employees-shift', a));

  return { ...state, status };
};

const clearReportsRequest = (state) => ({ ...state, ...initialState });

export const reducer = createReducer(initialState, {
  [ReportsTypes.CREATE_CLIENT_GOAL_FOR_BONUS_SUCCESS]: createClientGoalForBonusSuccess,
  [ReportsTypes.UPDATE_CLIENT_GOAL_FOR_BONUS_SUCCESS]: updateClientGoalForBonusSuccess,

  [ReportsTypes.GET_MTDYTD_CLIENT_UNCATEGORIZED_REQUEST]: getMTDYTDClientUncategorizedRequest,
  [ReportsTypes.GET_MTDYTD_CLIENT_UNCATEGORIZED_SUCCESS]: getMTDYTDClientUncategorizedSuccess,
  [ReportsTypes.GET_MTDYTD_CLIENT_UNCATEGORIZED_FAILURE]: getMTDYTDClientUncategorizedFailure,

  [ReportsTypes.GET_YTD_CLIENT_STATS_REQUEST]: getYTDClientStatsRequest,
  [ReportsTypes.GET_YTD_CLIENT_STATS_SUCCESS]: getYTDClientStatsSuccess,
  [ReportsTypes.GET_YTD_CLIENT_STATS_FAILURE]: getYTDClientStatsFailure,

  [ReportsTypes.GET_MTD_PAST_YEARS_CLIENT_STATS_REQUEST]: getMTDPastYearsClientStatsRequest,
  [ReportsTypes.GET_MTD_PAST_YEARS_CLIENT_STATS_SUCCESS]: getMTDPastYearsClientStatsSuccess,
  [ReportsTypes.GET_MTD_PAST_YEARS_CLIENT_STATS_FAILURE]: getMTDPastYearsClientStatsFailure,

  [ReportsTypes.GET_DAILY_EMPLOYEES_SHIFT_REQUEST]: getDailyEmployeesShiftRequest,
  [ReportsTypes.GET_DAILY_EMPLOYEES_SHIFT_SUCCESS]: getDailyEmployeesShiftSuccess,
  [ReportsTypes.GET_DAILY_EMPLOYEES_SHIFT_FAILURE]: getDailyEmployeesShiftFailure,

  [ReportsTypes.GET_WEEKLY_EMPLOYEES_SHIFT_REQUEST]: getWeeklyEmployeesShiftRequest,
  [ReportsTypes.GET_WEEKLY_EMPLOYEES_SHIFT_SUCCESS]: getWeeklyEmployeesShiftSuccess,
  [ReportsTypes.GET_WEEKLY_EMPLOYEES_SHIFT_FAILURE]: getWeeklyEmployeesShiftFailure,

  [ReportsTypes.CLEAR_REPORTS_REQUEST]: clearReportsRequest,
});
